import script from "./EquipoeditorialView.vue?vue&type=script&setup=true&lang=js"
export * from "./EquipoeditorialView.vue?vue&type=script&setup=true&lang=js"

import "./EquipoeditorialView.vue?vue&type=style&index=0&id=d31cd194&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d31cd194"]])

export default __exports__